
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.14 13.25v-1.362a2.72 2.72 0 00-2.72-2.722H4.57a2.72 2.72 0 00-2.72 2.722v1.361m8.866-9.527a2.722 2.722 0 11-5.444 0 2.722 2.722 0 015.444 0zM5.2 13.5h4.72","stroke":"#593289","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.15 11.8l1.6 1.72-1.6 1.72","stroke":"#593289","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    